import styled from "styled-components";
import { colors } from "../../../utils";
import { styled as muiStyled, Chip } from '@mui/material';

export const CenterWrapper = styled.div`
  background-color: ${colors.white};
  padding: 2vw;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const HeadingContainer = styled.div`
    display: flex;
    gap: 8px;
`

export const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

export const ChipContainer = styled.div`
    display: flex;
    gap: 8px;
    overflow-x: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
        display: none;
    }
`

export const StyledChip = muiStyled(Chip)(({ isHighlighted }) => ({
  border: `1px solid ${colors.PrimaryPurple500}`,
  color: isHighlighted ? "#fff" : "#8F38EF",
  backgroundColor: isHighlighted ? "#AA7CFB" : "transparent",
  borderRadius: "23px",
  cursor: "pointer",
  padding: "8px 16px 8px 16px",
  fontWeight: isHighlighted ? "600" : "400",
  flexShrink: 0,
  "&:hover": {
    backgroundColor: isHighlighted ? "#AA7CFB" : "#F5F0FF",
  },
}));

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const QuestionItem = styled.div`
    border: 1px solid ${props => (props.isExpanded ? '#9B5AF8' : '#CED4DA')};
    background-color: #F6F7F9;
    padding: 16px;
    border-radius: 8px;
`

export const QuestionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;

export const QuestionText = styled.h4`
    margin: 0;
    color: #212529;
    line-height: 24px;
    font-size: 16px;
    font-weight: 700;
    font-family: "DM Sans", sans-serif;
`;

export const AnswerText = styled.div`
    margin: 8px 0 0;
    color: #565556;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-family: "DM Sans", sans-serif;

    ul {
        list-style-type: disc;
        padding-left: 20px;
        margin: 8px 0;
    }

    li {
        margin-bottom: 8px;
    }

    strong {
        color: #333;
    }
`;